import { render, staticRenderFns } from "./ReorderSettingTable.vue?vue&type=template&id=81141bb0"
import script from "./ReorderSettingTable.vue?vue&type=script&lang=ts"
export * from "./ReorderSettingTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports